// Server-safe public API for Firebase/GA4 analytics. This file is statically imported into
// the SSR bundle (via _app.tsx), so it holds NO firebase imports itself. All firebase code
// lives in ./firebase-analytics-impl and is loaded lazily via dynamic import — which only
// ever runs client-side, so the browser-only firebase/analytics package never evaluates
// during SSR. The import() is cached after the first call, so repeat calls are cheap.

// Kick off the async Analytics boot. No-op on the server; idempotent and self-gating in
// the impl. Safe to call from any event helper.
export const initFirebaseAnalytics = (): void => {
  if (typeof window === 'undefined') return;
  void import('./firebase-analytics-impl').then((m) => m.boot());
};

// Report a GA4 event. Boots Analytics on demand and queues the event until it's ready in
// the impl, so no caller can lose an event to the async config fetch; a no-op on the server.
export const logAnalyticsEvent = (eventName: string, params?: Record<string, unknown>): void => {
  if (typeof window === 'undefined') return;
  void import('./firebase-analytics-impl').then((m) => m.log(eventName, params));
};
